import styled from "styled-components";
import { pxToRem } from "../../../styles/utils";


export const ButtonContainer = styled.div`
  position: relative; /* Для позиционирования тултипа */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(6)};
  border: none;
  border-radius: ${pxToRem(8)};
  cursor: pointer;
  background-color: rgba(250, 250, 250, 0);
  width: ${pxToRem(34)};

  &:hover {
    transform: scale(1.05);
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const ButtonIcon = styled.img`
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
`;

export const Tooltip = styled.div<{ visible?: boolean }>`
  visibility: ${props => (props.visible ? "visible" : "hidden")};
  opacity: ${props => (props.visible ? "1" : "0")};
  text-align: center;
  padding: ${pxToRem(4)} ${pxToRem(8)};
  font-size: ${pxToRem(12)};
  position: absolute;
  bottom: 100%; 
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: opacity 0.3s ease;
`;


